import React, {useState, useEffect, useRef} from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { fetchProfile, reset } from '../login/userSlice';
import LeadForm from './LeadForm';
import axios from 'axios';
import LeadThankYou from './LeadThankYou';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
import styles from '../styles/lead/Lead.module.scss';
import ConnectBlock from '../login/ConnectBlock';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {faExclamationCircle, faChevronRight, faCheckCircle} from '@fortawesome/free-solid-svg-icons';
import LoadingFullPage from '../elements/LoadingFullPage';
import SuccessMessage from '../elements/SuccessMessage';


const LeadFlow = (props) => {
    const {fields, provider, defaultAmount, defaultCurrency, defaultTerm, defaultLoanType, defaultBank, defaultFormData} = props;
    const isMounted = useRef(null);

    const [step, editStep] = useState('form');
    const [leadId, editLeadId] = useState(false);
    const [leadStatus, editLeadStatus] = useState(false);
    const [userEmail, editUserEmail] = useState(false);
    const [subscribeResponse, editSubscribeResponse] = useState(false);
    const user = useSelector(state => state.user);
    const [isLoading, editIsLoading] = useState(false);
    const [error, editError] = useState(false);

    const dispatch = useDispatch();

    useEffect( ()=>{
        let mainHtml = document.getElementById('main');
        mainHtml.scrollIntoView({behavior: "smooth"});
        if (step=='final') {
            refreshProfile();
        }
    }, [step]
    )

    useEffect( ()=>{
        editStep('form');
    }, [provider]
    )

    useEffect( ()=>{
        if (user.isLoggedIn && leadId>0 ) {
            if (step=='signup' || step=='login') {
                attachLeadToUser();
            }
        }

    }, [user.isLoggedIn]
    )

    useEffect( ()=>{
        if (user.status !== 'idle' && user.status !='loading') {
            editIsLoading(false);
        } 
    }, [user.status]
    )

    const goToFinalStep = () => { editStep('final')}
    const goToForm = () => { editStep('form'); editError(false);}

    const showStep = (step) => {
        let html, title, info;

        switch(step) {
            case 'form':
                html =  
                    <LeadForm 
                        fields={fields}
                        provider={provider} 
                        editStep={editStep}
                        editLeadId={editLeadId}
                        editUserEmail={editUserEmail}
                        defaultAmount={defaultAmount}
                        defaultCurrency={defaultCurrency}
                        defaultTerm={defaultTerm}
                        defaultLoanType={defaultLoanType}
                        defaultBank={defaultBank}
                        defaultFormData={defaultFormData}
                        handleSubscribe={editSubscribeResponse}
                        handlePageLoad={editIsLoading}
                        editLeadStatus={editLeadStatus}
                    />;
                    title = `Credite Online ${provider}`;
                    info = 'Completează formularul și vei fi contactat telefonic de către partenerul Conso.';
                break;
            case 'login':
            case 'signup':
                html = 
                <>
                    <ConnectBlock 
                        onboard={step== 'login' ? 'login' : 'signup'}
                        email={userEmail}
                    />
                    <Col xs={12} md={8} className="mx-auto px-0 py-3">
                        <div className="text-center pb-3 mt-0 px-5">
                            <Button variant="secondary" className="w-100" onClick={goToFinalStep}>
                                <FontAwesomeIcon icon={faChevronRight} className="mr-2" height="16" width="16" />
                                Finalizare aplicație, fără cont
                            </Button>
                        </div>
                    
                    </Col>
                    
                </>;
                title = `Salvează aplicația în cont`;
                info = 'Conectează-te în contul tău și vei putea apoi verifica situația de la Biroul de Credit';
                break;
            case 'final':
                html =  
                    <LeadThankYou
                        leadId={leadId}
                        subscribe={subscribeResponse}
                        userEmail={userEmail}
                        leadStatus={leadStatus}
                        leadProvider={provider}
                    />;
                title = 'Aplicație finalizată';
                info = '';
                break;
        }
        return {
            html, title, info
        }
    }

    let stepResult = showStep(step);

    const attachLeadToUser = async()=> {
        try {
            editIsLoading(true);
            const url = process.env.NEXT_PUBLIC_API + `/api/user/lead/assign/${leadId}`;
            const response = await axios ({
                method: 'post',
                url,
                headers: {'Content-Type': 'application/json'},
                withCredentials: true,
            });

            const data = response.data;
            if (data.status) {
                editStep('final');
            }
            editIsLoading(false);

        } catch(err) {
            editIsLoading(false);
            editError('Te rugăm să încerci mai târziu.')
        }
    }

    const refreshProfile = async() => {
        try {
            if (user.isLoggedIn) {
                const resultAction = await dispatch(fetchProfile());
            }
        } catch(err) {
            dispatch(reset());
        }
    }

    return (
        <>  {error ? <SuccessMessage 
                        title="Eroare"
                        message={error}
                        onClose={goToForm}
                    /> :
                (isLoading ? 
                <LoadingFullPage message="Te rugăm să aștepți" /> 
                : 
                <Container>
                    <Row>
                        <Col lg={8} xs={12} className="mx-auto">
                            <h1 className="heading1 mt-3 mb-2 font-weight-bold text-center black-text">
                                {stepResult.title}
                            </h1>
                            <p className={`text-center text-muted ${styles.description}`}>
                                {stepResult.info}
                            </p>
                        </Col>
                        <Col lg={8} xs={12} className={`mx-auto pt-3`}>
                            {stepResult.html}
                        </Col>
                    </Row>
                </Container>
                
                )
            }
        </>
        
    )
}

export default LeadFlow;